import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/StartAssignmentBtn';
// FOR ONE GRAPHQL QUERY
export const START_ASSIGNMENT = defineAsyncActionTypes(`${prefix}/START_ASSIGNMENT`);



// WEBPACK FOOTER //
// ./src/store/graphql/StartAssignmentBtn/action-types.js